import { AppShell } from "./layout/AppShell.js";
import { OverviewPage } from "./pages/overview/OverviewPage.js";
import { TasksPage } from "./pages/tasks/TasksPage.js";
import { PipelinePage } from "./pages/pipeline/PipelinePage.js";
import { CredentialsPage } from "./pages/credentials/CredentialsPage.js";
import { AutomationsPage } from "./pages/automations/AutomationsPage.js";
import { ModelsPage } from "./pages/models/ModelsPage.js";
import { FoldedVariantsPage } from "./pages/folded/FoldedVariantsPage.js";
import { OfferingsPage } from "./pages/offerings/OfferingsPage.js";
import { ArticlesPage } from "./pages/articles/ArticlesPage.js";
import { ContentDbPage } from "./pages/content-db/ContentDbPage.js";
import { EntitiesPage } from "./pages/entities/EntitiesPage.js";
import { HelpPage } from "./pages/help/HelpPage.js";
import { AudiencePage } from "./pages/audience/AudiencePage.js";
import { AuditPage } from "./pages/audit/AuditPage.js";
import { SourcesPage } from "./pages/sources/SourcesPage.js";
import { KeywordResearchPage } from "./pages/research/KeywordResearchPage.js";
import { DistributionPage } from "./pages/distribution/DistributionPage.js";
import { CalendarPage } from "./pages/calendar/CalendarPage.js";
import { VideoPage } from "./pages/video/VideoPage.js";
import { ErrorsPage } from "./pages/errors/ErrorsPage.js";
import { SpendPage } from "./pages/spend/SpendPage.js";
import { BrandPage } from "./pages/brand/BrandPage.js";

export function App() {
  return (
    <AppShell
      render={(route) => {
        switch (route) {
          case "overview":     return <OverviewPage />;
          case "tasks":        return <TasksPage />;
          case "sources":      return <SourcesPage />;
          case "research":     return <KeywordResearchPage />;
          case "pipeline":     return <PipelinePage />;
          case "content":      return <ArticlesPage />;
          case "content-db":   return <ContentDbPage />;
          case "entities":     return <EntitiesPage />;
          case "audience":     return <AudiencePage />;
          case "audit":        return <AuditPage />;
          case "automations":  return <AutomationsPage />;
          case "models":       return <ModelsPage />;
          case "folded":       return <FoldedVariantsPage />;
          case "offerings":    return <OfferingsPage />;
          case "credentials":  return <CredentialsPage />;
          case "errors":       return <ErrorsPage />;
          case "spend":        return <SpendPage />;
          case "brand":        return <BrandPage />;
          case "help":         return <HelpPage />;
          case "distribution": return <DistributionPage />;
          case "calendar":     return <CalendarPage />;
          case "video":        return <VideoPage />;
          default:             return <OverviewPage />;
        }
      }}
    />
  );
}
